export default __webpack_public_path__ + "static/media/yacht_moon_sunset.9c0993de.jpg";